import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles.css';
import './pwa';
import './lib/theme';
import { startSyncController } from './sync/useSync';
import { primeSnapshot } from './db/snapshot';
import { startSessionTokenRefresh } from './auth/session';

startSessionTokenRefresh();
startSyncController();
void primeSnapshot();

import ScanPrompt from './screens/ScanPrompt';
import Complaints from './screens/Complaints';
import HomeGate from './screens/HomeGate';
import SignIn from './screens/SignIn';
import Profile from './screens/Profile';
import OperatorDashboard from './screens/OperatorDashboard';
import DailyLogView from './screens/DailyLogView';
import TagResolve from './screens/TagResolve';
import ReadingForm from './screens/ReadingForm';
import Success from './screens/Success';
import PendingSyncs from './screens/PendingSyncs';
import NotFound from './screens/NotFound';
import Protected from './components/Protected';
import ErrorBoundary from './components/ErrorBoundary';

import AdminLayout from './screens/admin/AdminLayout';
import Dashboard from './screens/admin/Dashboard';
import EquipmentAdmin from './screens/admin/EquipmentAdmin';
import TagsAdmin from './screens/admin/TagsAdmin';
import OperatorsAdmin from './screens/admin/OperatorsAdmin';
import TemplatesAdmin from './screens/admin/TemplatesAdmin';
import ThresholdsAdmin from './screens/admin/ThresholdsAdmin';
import ReadingsAdmin from './screens/admin/ReadingsAdmin';
import PmsReportsAdmin from './screens/admin/PmsReportsAdmin';
import PmsSchedulerAdmin from './screens/admin/PmsSchedulerAdmin';
import TrendsAdmin from './screens/admin/TrendsAdmin';
import AdminAccount from './screens/admin/AdminAccount';
import DailyLogAdmin from './screens/admin/DailyLogAdmin';
import MaterialsReportAdmin from './screens/admin/MaterialsReportAdmin';
import AuditAdmin from './screens/admin/AuditAdmin';
import SettingsAdmin from './screens/admin/SettingsAdmin';

const router = createBrowserRouter([
  // the whole app is behind sign-in; /signin is the only anonymous screen
  { path: '/signin', element: <SignIn /> },
  { path: '/admin/login', element: <SignIn /> },

  { path: '/', element: <Protected><HomeGate /></Protected> },
  { path: '/scan', element: <Protected><ScanPrompt /></Protected> },
  { path: '/dashboard', element: <Protected><OperatorDashboard /></Protected> },
  { path: '/daily', element: <Protected><DailyLogView /></Protected> },
  { path: '/profile', element: <Protected><Profile /></Protected> },
  // NFC tags are written with this URL: https://<host>/t/<TAG_CODE>
  { path: '/t/:code', element: <Protected><TagResolve /></Protected> },
  { path: '/t/:code/form', element: <Protected><ReadingForm /></Protected> },
  { path: '/success', element: <Protected><Success /></Protected> },
  { path: '/pending', element: <Protected><PendingSyncs /></Protected> },
  { path: '/complaints', element: <Protected><Complaints /></Protected> },
  {
    path: '/admin',
    element: <Protected admin><AdminLayout /></Protected>,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'equipment', element: <EquipmentAdmin /> },
      { path: 'tags', element: <TagsAdmin /> },
      { path: 'operators', element: <OperatorsAdmin /> },
      { path: 'templates', element: <TemplatesAdmin /> },
      { path: 'thresholds', element: <ThresholdsAdmin /> },
      { path: 'readings', element: <ReadingsAdmin /> },
      { path: 'pms', element: <PmsReportsAdmin /> },
      { path: 'pms/scheduler', element: <PmsSchedulerAdmin /> },
      { path: 'trends', element: <TrendsAdmin /> },
      { path: 'daily', element: <DailyLogAdmin /> },
      { path: 'materials-report', element: <MaterialsReportAdmin /> },
      { path: 'audit', element: <AuditAdmin /> },
      { path: 'settings', element: <SettingsAdmin /> },
      { path: 'account', element: <AdminAccount /> },
    ],
  },

  { path: '*', element: <NotFound /> },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <RouterProvider router={router} />
    </ErrorBoundary>
  </React.StrictMode>,
);
